import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useFetchWithBody, usePost } from '../../api/reactQueryCustomHooks';
import {
    Box, Button, Grid, Paper,
    TableHead, TableRow, TextField, Typography, FormControl, InputLabel,
    Select, MenuItem, IconButton, InputAdornment, Popover, useMediaQuery, Chip, Alert, AlertTitle, ListSubheader,
    CircularProgress
} from '@mui/material';

import { format, toDate } from 'date-fns';
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory } from '../../constants/enum';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faDownload, faDownLong, faFilter, faInfo, faRefresh, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ErrorCard, LoadingCard, MainContainer, MUIDataTable, NoDataCard } from '../../components';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { head } from 'lodash';
import { toast } from 'react-toastify';
import { Autocomplete, AutocompleteItem, Checkbox } from '@heroui/react';

export const ALL_COLUMNS = {

    Party: { label: "Party", group: "party", type: "string" },
    Broker: { label: "Broker", group: "broker", type: "string" },
    invDate: { label: "Inv. Date", group: "none", type: "date" },
    voutype: { label: "Bill Type", group: "none", type: "string" },
    invno: { label: "Inv.No", group: "none", type: "string" },
    DueDays: { label: "Due Days", group: "none", type: "string" },
    DueDate: { label: "Due Date", group: "none", type: "date" },
    invPcs: { label: "Pcs", group: "none", type: "number" },
    invWeight: { label: "Weight", group: "none", type: "number" },
    invAmt: { label: "Inv.Amount", group: "none", type: "number" },
    gstStatus: { label: "Gst Status", group: "none", type: "string" },
    TdsAmt: { label: "TDS Amount", group: "none", type: "number" },
    PayAmt: { label: "Pay Amount", group: "none", type: "number" },
    retAmt: { label: "Ret.Amount", group: "none", type: "number" },
    BalanceAmt: { label: "Balance Amount", group: "none", type: "number" },
    dif_day_inv_date: { label: "Diff.Days Inv.Date", group: "none", type: "string" },
    dif_day_due_date: { label: "Diff.Days Due.Date", group: "none", type: "string" },


};

export const getColumns = (groupBy, activeTab, useMktAsMfg = true) => {
    return Object.entries(ALL_COLUMNS)
        .filter(([key, col]) => {
            // Handle SL_Code
            const bothgroup = ['invPcs', 'invWeight', 'invAmt', 'TdsAmt', 'PayAmt', 'retAmt', 'BalanceAmt']
            if (bothgroup.includes(key))
                return groupBy === "none" || groupBy === "party" || groupBy === "broker";
            if (key === "Party") {
                return groupBy === "none" || groupBy === "party";
            }

            if (key === "Broker") {
                return groupBy === "none" || groupBy === "broker";
            }

            // Handle grouped columns
            if (col.group && col.group !== groupBy) return false;


            return true;
        })
        .map(([key, col]) => ({ key, ...col }));
};
;


const OutstandingReport = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [tabValue, setTabValue] = useState(0);
    const [activeTab, setActiveTab] = useState('all');
    const { compCode, compName, startDate, endDate } = useSelector((state) => state.company);
    const tableRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentFilterColumn, setCurrentFilterColumn] = useState('');
    const [showReport, setShowReport] = useState(false);
    const [groupBy, setGroupBy] = useState('none');
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
    const [filterField, setFilterField] = useState('invDate');
    const [reportData, setReportData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isOverDueBill, setIsOverDueBill] = useState(false);
    const [columnFilters, setColumnFilters] = useState({
        Party: '',
        invDate: '',
        voutype: '',
        invno: '',
        DueDays: '',
        DueDate: '',
        invPcs: '',
        invWeight: '',
        gstStatus: '',
        invAmt: '',
        TdsAmt: '',
        PayAmt: '',
        retAmt: '',
        BalanceAmt: '',
        dif_day_inv_date: '',
        dif_day_due_date: '',
        Broker: ''
    });

    const [filters, setFilters] = useState({
        out_type: 'R',
        party_id: '',
        party_name: '',
        diff_duedate: new Date(),
        showAge1: 0,
        showAge2: 0,
        compcode: compCode,
        fromDate: dayjs(startDate).format("YYYY-MM-DD"),// startDate.split('T')[0],
        toDate: dayjs(endDate).format("YYYY-MM-DD"),//endDate.split('T')[0]//new Date()
        pkt_type: 'ALL'
    });

    const exportColumnKeys = [
        "Party",
        "invDate",
        "voutype",
        "invno",
        "DueDays",
        "DueDate",
        "invPcs",
        "invWeight",
        "invAmt",
        "gstStatus",
        "TdsAmt",
        "PayAmt",
        "retAmt",
        "BalanceAmt",
        "dif_day_inv_date",
        "dif_day_due_date",
        "Broker"
    ];

    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingInwardItem",
        inputData: {
            mod_name: ENUM_MOD_NAME.GeneralSettings
        }
    })
    useEffect(() => {
        if (modSetting && modSetting.length > 0) {
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
            setIsUseMfgNoAsMktno(mktSetting)
        }
    }, [modSetting])

    const {
        isLoading,
        data: accountsData = [],
        isError: isAccountsError,
        error: accountsError,
    } = useFetchWithBody({
        url: apiRoute.outstanding.getAccount,
        queryKey: ['accounts'],
        inputData: {},
    });

    // const filteredAccounts = accountsData.filter(account =>
    //     account.AC_DESC.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     account.AC_ID.toString().includes(searchTerm)
    // );

    const {
        mutate: fetchReport,
        isPending,
        isError,
        data
    } = usePost({
        url: apiRoute.outstanding.getReportData,
        queryKey: 'partyDetails',
        onSuccessTasks: (data) => {
            const formattedData = data.map(item => ({
                Party: item.party || '',
                invDate: item.inv_date,
                voutype: item.vou_type || '',
                invno: item.inv_no || '',
                DueDays: item.duedays || 0,
                DueDate: item.duedate,
                gstStatus: item.GST_Status || '',
                invPcs: parseFloat(item.qty) || 0,
                invAmt: parseFloat(item.inv_amount) || 0,
                invWeight: parseFloat(item.inv_weight) || 0,
                TdsAmt: parseFloat(item.tds_amount) || 0,
                PayAmt: parseFloat(item.pay_amount) || 0,
                retAmt: parseFloat(item.ret_amount) || 0,
                BalanceAmt: parseFloat(item.balance_amount) || 0,
                dif_day_inv_date: item.diff_days_inv_date || 0,
                dif_day_due_date: item.diff_days_due_date || 0,
                Broker: item.broker || ''
            }));
            setReportData(formattedData);
            // setFilteredData(formattedData);
            setShowReport(true);
            // // setFromDate(null);
            // // setToDate(null);
            // setFilterField('inv_date');
        },
    });
    console.log(filters)



    // Apply column filters to the data
    const filteredData = useMemo(() => {
        if (!reportData.length) return [];
        return reportData.filter(row => {
            return Object.entries(columnFilters).every(([key, value]) => {
                if (!value) return true;
                const rowValue = row[key] || '';
                return String(rowValue).toLowerCase().includes(String(value).toLowerCase());
            });
        });
    }, [reportData, columnFilters]);




    const filteredAndGroupedData = useMemo(() => {
        if (!reportData?.length) return [];

        /* ================= FILTER (COLUMN) ================= */
        let data = filteredData;

        // let data = reportData.filter(row =>
        //     Object.entries(columnFilters).every(([key, value]) => {
        //         if (!value) return true;
        //         return String(row[key] ?? '')
        //             .toLowerCase()
        //             .includes(String(value).toLowerCase());
        //     })
        // );

        /* ================= FILTER (DATE RANGE) ================= */

        if (filters?.fromDate || filters?.toDate) {
            data = filteredData.filter(item => {
                const dateStr = item[filterField === 'invDate' ? 'invDate' : 'DueDate'];
                if (!dateStr) return false;

                const [day, month, year] = dateStr.split('-');
                const date = new Date(`${year}-${month}-${day}`);

                if (filters?.fromDate && date < filters?.fromDate) return false;
                if (filters?.toDate && date > filters?.toDate) return false;

                return true;
            });
        }
        console.log(isOverDueBill)
        if (isOverDueBill) {
            const tmp = data.filter((ele) => ele?.dif_day_due_date > 1)
            data = tmp
        }

        /* ================= NO GROUPING ================= */

        if (groupBy === 'none') return data;

        /* ================= GROUPING ================= */

        const groupedData = {};

        const getGroupKey = (row) => {
            switch (groupBy) {
                case 'broker':
                    return row.Broker || 'Unknown Broker';
                case 'party':
                    return row.Party || 'Unknown Party';
                default:
                    return 'all';
            }
        };

        const initGroup = (row, key) => ({
            groupKey: key,
            Broker: groupBy === 'broker' ? row.Broker : 'Multiple Brokers',
            Party: groupBy === 'party' ? row.Party : 'Multiple Parties',
            invDate: 0,
            DueDays: 0,
            invPcs: 0,
            invWeight: 0,
            invAmt: 0,
            TdsAmt: 0,
            PayAmt: 0,
            retAmt: 0,
            BalanceAmt: 0,
            dif_day_inv_date: 0,
            dif_day_due_date: 0,

            // weighted helpers
            //  _rateWeightedSum: 0,
            //  _weightSum: 0,

            _children: []
        });

        data.forEach(row => {
            const key = getGroupKey(row);

            if (!groupedData[key]) {
                groupedData[key] = initGroup(row, key);
            }

            const group = groupedData[key];

            const add = (field) => {
                group[field] += Number(row[field]) || 0;
            };

            add('DueDays');
            add('invPcs');
            add('invWeight');
            add('invAmt');

            add('TdsAmt');
            add('PayAmt');
            add('retAmt');
            add('BalanceAmt');
            add('dif_day_inv_date');
            add('dif_day_due_date');

            // Example weighted logic (if needed)
            // if (row.Rate && row.Weight) {
            //     group._rateWeightedSum += Number(row.Rate) * Number(row.Weight);
            //     group._weightSum += Number(row.Weight);
            // }

            group._children.push(row);
        });

        /* ================= FINALIZE ================= */

        return Object.values(groupedData)
            .map(({ _rateWeightedSum, _weightSum, ...rest }) => ({
                ...rest,
                Rate: _weightSum ? _rateWeightedSum / _weightSum : 0
            }))
            .sort((a, b) =>
                String(a.groupKey).localeCompare(String(b.groupKey))
            );

    }, [
        filteredData,
        columnFilters,
        filters,
        filterField,
        groupBy,
        isOverDueBill
    ]);





    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };



    // const handleTabChange = (event, newValue) => {
    //   setTabValue(newValue);
    //   setFilters(prev => ({ ...prev, isSummary: newValue === 1 }));
    // };ry

    const filteredAccounts = accountsData.filter(account =>
        account.AC_DESC.toLowerCase().includes(searchTerm.toLowerCase()) ||
        account.AC_ID.toString().includes(searchTerm)
    );
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleAutoCompleteChange = (value, name) => {

        setFilters(prev => ({
            ...prev,
            party_id: value || '',
        }));
    };

    // const handlePartyChange = (event, value) => {
    //     setFilters(prev => ({
    //         ...prev,
    //         party_id: value ? value.AC_ID : '',
    //         party_name: value ? value.AC_DESC : ''
    //     }));
    // };

    const handleDateChange = (date) => {
        setFilters((prev) => ({ ...prev, diff_duedate: date }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if ((filters.fromDate && filters.fromDate == 'Invalid Date')
            || (filters.toDate && filters.toDate == 'Invalid Date')) {
            toast.error("Invalid From Date / To Date", {
                "position": "top-center"
            })
        }
        else {
            setShowReport(false);
            const formattedData = {
                ...filters,
                diff_duedate: format(filters.diff_duedate, 'yyyy-MM-dd'),
                compcode: compCode,
                date_type: filterField,

            };
            fetchReport({ data: formattedData });
        }

        // refetch();
    };

    // console.log(filters)
    const handleReset = () => {
        setFilters({
            out_type: 'R',
            party_id: '',
            party_name: '',
            diff_duedate: new Date(),
            showAge1: 0,
            showAge2: 0,
            compcode: compCode,
            fromDate: dayjs(startDate).format("YYYY-MM-DD"),// startDate.split('T')[0],
            toDate: dayjs(endDate).format("YYYY-MM-DD"),// startDate.split('T')[0],
            pkt_type: 'ALL'
        });
        setFilterField("invDate")
        const params = {
            out_type: 'R',
            party_id: '',
            party_name: '',
            diff_duedate: new Date(),
            showAge1: 0,
            showAge2: 0,
            compcode: compCode,
            diff_duedate: format(filters.diff_duedate, 'yyyy-MM-dd'),
            compcode: compCode,
            fromDate: null,
            toDate: null
        };
        fetchReport({ data: params });
    };



    const calculateTotals = () => {
        const totals = {
            invWeight: 0,
            invAmt: 0,
            TdsAmt: 0,
            PayAmt: 0,
            retAmt: 0,
            BalanceAmt: 0
        };

        filteredData.forEach(row => {
            totals.invWeight += parseFloat(row.invWeight) || 0;
            totals.invAmt += parseFloat(row.invAmt) || 0;
            totals.TdsAmt += parseFloat(row.TdsAmt) || 0;
            totals.PayAmt += parseFloat(row.PayAmt) || 0;
            totals.retAmt += parseFloat(row.retAmt) || 0;
            totals.BalanceAmt += parseFloat(row.BalanceAmt) || 0;
        });

        return totals;
    };


    const totals = calculateTotals();

    const getReportTitle = () => {
        return filters.out_type === 'R' ? 'Receivable Outstanding Report' : 'Payable Outstanding Report';
    };



    const safeDate = (val) => {
        const d = dayjs(val);
        return d.isValid() ? d : null;
    };


    const headCssStyle = { fontSize: "0.7rem", lineHeight: 1.3, textTransform: "uppercase", backgroundColor: '#f0f0f0', fontWeight: 600, color: '#3c3c3c' }
    const columns = useMemo(() => getColumns(groupBy, activeTab, isUseMfgNoAsMktno), [isUseMfgNoAsMktno, groupBy]);
    if (isError) {
        return <ErrorCard />
    }
    if (isLoading) {
        return <LoadingCard />
    }
    return (
        <MainContainer
            pageName={`Oustanding Report`}
            breadcrumbs={["Reports", "Outstanding Report"]}
        >
            <Box sx={{
                p: isMobile ? 1 : 3,
                backgroundColor: 'background.default',
                minHeight: '100vh',

            }}>
                {/* Header Section */}

                <Box
                    sx={{
                        position: "relative",

                        display: "flex",

                        flexDirection: {
                            xs: "column",
                            md: "row",
                        },

                        justifyContent: "space-between",

                        alignItems: {
                            xs: "flex-start",
                            md: "center",
                        },

                        gap: 1.5,

                        mb: 1.2,

                        px: {
                            xs: 1.3,
                            sm: 1.6,
                        },

                        py: {
                            xs: 0.9,
                            sm: 1,
                        },

                        minHeight: 44,

                        overflow: "hidden",

                        background:
                            "#FFFFFF",

                        border: "1px solid #bae6fd",

                        borderRadius: "8px",

                        boxShadow:
                            "0 1px 4px rgba(14, 116, 144, 0.08)",

                        transition:
                            "all 0.2s ease",

                        "&:hover": {
                            borderColor: "#7dd3fc",

                            boxShadow:
                                "0 2px 7px rgba(14, 116, 144, 0.10)",
                        },

                        // Left accent
                        "&::before": {
                            content: '""',

                            position: "absolute",

                            left: 0,
                            top: 0,
                            bottom: 0,

                            width: "4px",

                            background:
                                "linear-gradient(180deg, #0284c7, #2563eb)",
                        },
                    }}
                >
                    {/* ==============================
                       REPORT TITLE
                   =============================== */}

                    <Box
                        sx={{
                            display: "flex",

                            alignItems: "center",

                            minWidth: 0,

                            pl: 0.5,
                        }}
                    >
                        {/* Title Indicator */}
                        <Box
                            sx={{
                                width: 6,
                                height: 6,

                                flexShrink: 0,

                                mr: 1,

                                borderRadius: "50%",

                                backgroundColor: "#2563eb",

                                boxShadow:
                                    "0 0 0 3px rgba(37, 99, 235, 0.10)",
                            }}
                        />

                        <Typography
                            variant="h4"
                            sx={{
                                fontSize: {
                                    xs: "0.9rem",
                                    sm: "0.95rem",
                                    md: "1rem",
                                },

                                fontWeight: 600,

                                color: "#0f3fa8",

                                letterSpacing: "-0.2px",

                                lineHeight: 1.3,

                                whiteSpace: {
                                    xs: "normal",
                                    md: "nowrap",
                                },

                                overflow: "hidden",

                                textOverflow: "ellipsis",
                            }}
                        >
                            {getReportTitle()}
                        </Typography>
                    </Box>

                    {/* ==============================
                       RIGHT SIDE ACTIONS
                   =============================== */}


                </Box>


                {/* Filters Section */}
                <div className='p-5'>

                    <form onSubmit={handleSubmit}>


                        <Grid
                            container
                            spacing={1.5}
                            alignItems="center"
                            sx={{
                                p: 1.5,
                                borderRadius: 2,
                                backgroundColor: "#f8fafc",
                                border: "1px solid #e2e8f0",

                                "& .MuiFormControl-root": {
                                    width: "100%",
                                },

                                "& .MuiOutlinedInput-root": {
                                    minHeight: 38,
                                    borderRadius: "7px",
                                    backgroundColor: "#fff",
                                    fontSize: "13px",

                                    "& fieldset": {
                                        borderColor: "#cbd5e1",
                                    },

                                    "&:hover fieldset": {
                                        borderColor: "#94a3b8",
                                    },

                                    "&.Mui-focused fieldset": {
                                        borderColor: "#2563eb",
                                        borderWidth: "1.5px",
                                    },
                                },

                                "& .MuiInputLabel-root": {
                                    fontSize: "15px",
                                    color: "#393939",
                                    fontWeight: 700
                                },

                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "#2563eb",
                                },

                                "& .MuiAutocomplete-input": {
                                    padding: "3px 6px !important",
                                },

                                "& .MuiInputBase-input": {
                                    fontSize: "13px",
                                },

                                "& .MuiSelect-select": {
                                    display: "flex",
                                    alignItems: "center",
                                    minHeight: "38px",
                                    boxSizing: "border-box",
                                },

                                "& .MuiPickersInputBase-root": {
                                    minHeight: 38,
                                    borderRadius: "7px",
                                    backgroundColor: "#fff",
                                },

                                "& .MuiPickersOutlinedInput-notchedOutline": {
                                    borderColor: "#cbd5e1",
                                },

                                "& .MuiPickersInputBase-root:hover .MuiPickersOutlinedInput-notchedOutline":
                                {
                                    borderColor: "#94a3b8",
                                },

                                "& .MuiPickersInputBase-root.Mui-focused .MuiPickersOutlinedInput-notchedOutline":
                                {
                                    borderColor: "#2563eb",
                                    borderWidth: "1.5px",
                                },
                            }}
                        >
                            {/* =====================================================
        ROW 1
        5 ITEMS
    ====================================================== */}

                            {/* 1. Type */}
                            <Grid item xs={12} sm={6} md={3} lg={2.4}>
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ fontWeight: 600, }}>Type</InputLabel>

                                    <Select
                                        name="out_type"
                                        value={filters.out_type}
                                        onChange={handleChange}
                                        label="Type"
                                    >
                                        <MenuItem value="R">
                                            Receivable
                                        </MenuItem>

                                        <MenuItem value="G">
                                            Payable
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* 2. Search Party */}
                            <Grid item xs={12} sm={6} md={3} lg={2.4}>
                                <Autocomplete

                                    size="sm"
                                    radius="sm"
                                    name="party_id"
                                    color="default"
                                    variant="bordered"
                                    selectionMode="single"
                                    showScrollIndicators
                                    placeholder="-Select-"
                                    label="Search Party"
                                    className="w-full text-xs bg-white font-semibold "
                                    menuTrigger="input"
    //                                 classNames={{
    //     label: "text-blue-600 !important font-semibold group-data-[filled=true]:text-blue-600 group-data-[focus=true]:text-blue-600",
    // }}
                                    isClearable={true}
                                    isVirtualized
                                    defaultItems={accountsData || []}
                                    onSelectionChange={(e) =>
                                        handleAutoCompleteChange(e, "party_id")
                                    }
                                    selectedKey={filters.party_id}
                                >
                                    {(item) => (
                                        <AutocompleteItem
                                            key={item.AC_ID}
                                            classNames={{ title: "text-xs" }}
                                        >
                                            {item.AC_DESC}
                                        </AutocompleteItem>
                                    )}
                                </Autocomplete>
                                {/* <Autocomplete
                                    options={filteredAccounts}
                                    getOptionLabel={(option) => option.AC_DESC}
                                    value={
                                        accountsData.find(
                                            (account) =>
                                                account.AC_ID === filters.party_id
                                        ) || null
                                    }
                                    onChange={handlePartyChange}
                                    loading={isLoading}
                                    noOptionsText="No parties found"
                                    fullWidth
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Search Party"
                                            size="small"
                                            sx={{
                                                "& .MuiInputLabel-root": {
                                                    fontSize: "11px",
                                                    color: "#393939",
                                                    fontWeight: 700
                                                },
                                            }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {isLoading && (
                                                            <CircularProgress
                                                                size={17}
                                                                sx={{
                                                                    color: "#2563eb",
                                                                    mr: 1,
                                                                }}
                                                            />
                                                        )}

                                                        {
                                                            params.InputProps
                                                                .endAdornment
                                                        }
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                /> */}
                            </Grid>

                            {/* 3. As On Date */}
                            <Grid item xs={12} sm={6} md={3} lg={2.4}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                >
                                    <DatePicker
                                        label="As On Date"
                                        views={[
                                            "day",
                                            "month",
                                            "year",
                                        ]}
                                        format="DD/MM/YYYY"
                                        value={
                                            filters.diff_duedate
                                                ? dayjs(
                                                    filters.diff_duedate
                                                )
                                                : null
                                        }
                                        onChange={(newValue) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                diff_duedate:
                                                    newValue &&
                                                        dayjs(
                                                            newValue
                                                        ).isValid()
                                                        ? dayjs(
                                                            newValue
                                                        ).format(
                                                            "YYYY-MM-DD"
                                                        )
                                                        : null,
                                            }));
                                        }}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                                InputLabelProps: { sx: { fontWeight: 600 } }
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            {/* 4. Packet Type */}
                            <Grid item xs={12} sm={6} md={3} lg={2.4}>
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ fontWeight: 600 }}>
                                        Packet Type
                                    </InputLabel>

                                    <Select
                                        name="pkt_type"
                                        value={
                                            filters.pkt_type || "ALL"
                                        }
                                        onChange={handleFilterChange}
                                        label="Packet Type"
                                    >
                                        <MenuItem value="ALL">
                                            All
                                        </MenuItem>

                                        <MenuItem value="SNG">
                                            Single
                                        </MenuItem>

                                        <MenuItem value="MIX">
                                            Mix
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* 5. Filter By */}
                            <Grid item xs={12} sm={6} md={3} lg={2.4}>
                                <FormControl
                                    fullWidth
                                    size="small"
                                    disabled={!showReport}
                                >
                                    <InputLabel sx={{ fontWeight: 600 }}>
                                        Filter By
                                    </InputLabel>

                                    <Select
                                        value={filterField}
                                        label="Filter By"
                                        onChange={(e) =>
                                            setFilterField(
                                                e.target.value
                                            )
                                        }
                                    >
                                        <MenuItem value="invDate">
                                            Invoice Date
                                        </MenuItem>

                                        <MenuItem value="DueDate">
                                            Due Date
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* =====================================================
        ROW 2
        5 ITEMS
    ====================================================== */}

                            {/* 6. From Date */}
                            <Grid item xs={12} sm={6} md={3} lg={2.4}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                >
                                    <DatePicker
                                        label="From Date"
                                        views={[
                                            "day",
                                            "month",
                                            "year",
                                        ]}
                                        format="DD/MM/YYYY"
                                        value={
                                            filters.fromDate
                                                ? safeDate(
                                                    dayjs(
                                                        filters.fromDate
                                                    )
                                                )
                                                : null
                                        }
                                        onChange={(newValue) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                fromDate:
                                                    newValue &&
                                                        dayjs(
                                                            newValue
                                                        ).isValid()
                                                        ? dayjs(
                                                            newValue
                                                        ).format(
                                                            "YYYY-MM-DD"
                                                        )
                                                        : null,
                                            }));
                                        }}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                                InputLabelProps: { sx: { fontWeight: 600 } }
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            {/* 7. To Date */}
                            <Grid item xs={12} sm={6} md={3} lg={2.4}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                >
                                    <DatePicker
                                        label="To Date"
                                        views={[
                                            "day",
                                            "month",
                                            "year",
                                        ]}
                                        format="DD/MM/YYYY"
                                        value={
                                            filters.toDate
                                                ? dayjs(
                                                    filters.toDate
                                                )
                                                : null
                                        }
                                        onChange={(newValue) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                toDate:
                                                    newValue &&
                                                        dayjs(
                                                            newValue
                                                        ).isValid()
                                                        ? dayjs(
                                                            newValue
                                                        ).format(
                                                            "YYYY-MM-DD"
                                                        )
                                                        : null,
                                            }));
                                        }}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                                InputLabelProps: { sx: { fontWeight: 600 } }
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            {/* 8. Order By */}
                            <Grid item xs={12} sm={6} md={3} lg={2.4}>
                                <FormControl
                                    fullWidth
                                    size="small"
                                    disabled={!showReport}
                                >
                                    <InputLabel sx={{ fontWeight: 600 }}>
                                        Order By
                                    </InputLabel>

                                    <Select
                                        label="Order By"
                                        value={groupBy}
                                        onChange={(e) =>
                                            setGroupBy(
                                                e.target.value
                                            )
                                        }
                                    >
                                        <ListSubheader>
                                            Detail :
                                        </ListSubheader>

                                        <MenuItem value="none">
                                            Report Detail
                                        </MenuItem>

                                        <ListSubheader>
                                            Summary :
                                        </ListSubheader>

                                        <MenuItem value="party">
                                            Party
                                        </MenuItem>

                                        <MenuItem value="broker">
                                            Broker
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>



                            {/* 10. Search */}
                            <Grid item xs={12} sm={6} md={3} lg={2.4}>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    disabled={isPending}
                                    size="small"
                                    fullWidth
                                    startIcon={
                                        isPending ? (
                                            <CircularProgress
                                                size={16}
                                                color="inherit"
                                            />
                                        ) : (
                                            <FontAwesomeIcon
                                                icon={faSearch}
                                                style={{
                                                    fontSize: "12px",
                                                }}
                                            />
                                        )
                                    }
                                    sx={{
                                        height: 38,
                                        borderRadius: "7px",

                                        fontSize: "13px",
                                        fontWeight: 600,
                                        textTransform: "none",

                                        color: "#fff",

                                        background:
                                            "linear-gradient(135deg, #2563eb, #1d4ed8)",

                                        boxShadow:
                                            "0 2px 5px rgba(37,99,235,.22)",

                                        "&:hover": {
                                            background:
                                                "linear-gradient(135deg, #1d4ed8, #1e40af)",
                                            boxShadow:
                                                "0 4px 8px rgba(37,99,235,.28)",
                                        },

                                        "&.Mui-disabled": {
                                            background: "#93c5fd",
                                            color: "#fff",
                                        },
                                    }}
                                >
                                    {isPending
                                        ? "Searching..."
                                        : "SHOW"}
                                </Button>
                            </Grid>
                            {/* 9. Reset */}
                            <Grid item xs={12} sm={6} md={3} lg={2.4}>
                                <Button
                                    variant="outlined"
                                    onClick={handleReset}
                                    size="small"
                                    fullWidth
                                    startIcon={
                                        <FontAwesomeIcon
                                            icon={faRefresh}
                                            style={{
                                                fontSize: "12px",
                                            }}
                                        />
                                    }

                                    sx={{
                                        height: 34,
                                        minWidth: 88,
                                        px: 1.5,

                                        borderRadius: "7px",

                                        fontSize: "12px",
                                        fontWeight: 600,

                                        textTransform: "none",

                                        backgroundColor: "#eff6ff", border: "1px solid #bfdbfe", color: "#2563eb",

                                        boxShadow:
                                            "0 1px 2px rgba(15, 23, 42, 0.05)",

                                        transition: "all 0.2s ease",

                                        "&:hover": {
                                            backgroundColor: "#dbeafe", borderColor: "#93c5fd", color: "#1d4ed8",
                                            boxShadow:
                                                "0 2px 5px rgba(15, 23, 42, 0.10)",

                                            transform: "translateY(-1px)",
                                        },

                                        "&:active": {
                                            backgroundColor: "#cbd5e1",

                                            transform: "translateY(0)",
                                        },
                                    }}



                                >
                                    RESET
                                </Button>
                            </Grid>
                        </Grid>




                    </form>

                </div>

                {/* Error Message */}


                {/* Data Table Section */}
                <Paper sx={{
                    p: isMobile ? 1 : 1,
                    borderRadius: 3,
                    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.08)',
                    backgroundColor: 'background.paper'
                }} ref={tableRef}>
                    {/* Table Header */}


                    {/* Data Table */}
                    {reportData.length > 0 ? (
                        <>
                            <div className='text-right'>
                                <span
                                    className={`text-right p-1  rounded-lg border transition-all duration-200
                                                                     ${isOverDueBill
                                            ? "bg-orange-100 border-orange-400 shadow-sm"
                                            : "bg-orange-50 border-gray-200 hover:border-orange-300 hover:bg-orange-50"
                                        }
                                                                    `}
                                >
                                    <Checkbox
                                        size="md"
                                        color="secondary"
                                        isSelected={isOverDueBill}
                                        onValueChange={setIsOverDueBill}
                                        classNames={{
                                            base: "m-0",
                                            wrapper:
                                                "border-2 border-orange-400 rounded-md " +
                                                "after:bg-orange-600 after:border-orange-600",
                                            label:
                                                "text-xs font-semibold uppercase " +
                                                (isOverDueBill
                                                    ? "text-orange-700"
                                                    : "text-gray-600"),
                                        }}
                                    >
                                        Over Due BILL Only
                                    </Checkbox>
                                </span>
                            </div>
                            <Box sx={{ width: "100%", overflowX: "auto" }}>
                                <MUIDataTable
                                    data={filteredAndGroupedData}
                                    dataColumns={columns}
                                    reportTitle={`${filters.out_type === 'R' ? 'Receivable' : 'Payable'} Outstanding Report`}
                                    orderGroup={groupBy}
                                    enableCurrency={false}
                                    filterDate={filters}
                                    tradeLabel={`Type: ${filters.out_type === 'R' ? 'Receivable' : 'Payable'} `}
                                    companyName={compName.join(",")}
                                    hideIfZeroKeys={["TDSAmt", "DiscAmt", "DiscPer", "GSTAmt"]}
                                    exportColumnKeys={exportColumnKeys}
                                    higthLightParams={{
                                        col: "dif_day_due_date",
                                        type: "pos",
                                        style: "bg-amber-50 text-red-500 !important"
                                    }}
                                    enableHeaderFilter={true}

                                />
                            </Box>
                        </>
                    ) : (
                        !isPending && (
                            <NoDataCard />
                        )
                    )}
                </Paper>


            </Box>
        </MainContainer>
    );
};

export default OutstandingReport;
